module.exports = __webpack_public_path__ + "img/ic_launcher_background.ff93df5e.png";